/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */

import { getSemanticURL } from '../../router/app-router';
import { getResolvedTargetName } from '../../router/routing-manager';
import { ACTION_GETOBJECT } from '../../store/state/actions';
import { activateContainerItem, postProcess } from '../../store/state/actions/action-creators';
import { getDataContextName } from '../../container/container-utils';
import { processViewResponse } from '../../store/state/epics/util';
import { getObjectInfoID, getObjectClassName } from '../common-helper';
import { getContainerName, getDisplayCaseID } from '../../case/common-helper';
import type { Action } from '../../store/state/state-manager';
import type { DxAPIResponseObject } from '../../case/types';

export const handleWorkItemActivation = async (
  actionsOut: Action[],
  options: { activateContainerActionPayload: any; actionInPayload: any }
) => {
  const {
    activateContainerActionPayload: { semanticURL, containerItemID },
    actionInPayload,
    actionInPayload: { context: actionInContext, skipBrowserSemanticUrlUpdate, doDeleteCaseSummary }
  } = options;

  const containerName = getContainerName(ACTION_GETOBJECT, actionInPayload);
  const target = getResolvedTargetName(containerName, actionInContext);
  const context = getDataContextName(containerItemID);

  await processViewResponse(
    {
      directUrlUpdation: !skipBrowserSemanticUrlUpdate,
      semanticURL
    },
    actionInPayload,
    {
      acName:
        target /* [TODO]: we shouldn't use "acName" anywhere, setting this value..since app-router uses this logic */,
      containerName,
      target,
      context
    }
  );

  actionsOut.push(
    postProcess(activateContainerItem, {
      containerItemID,
      target,
      context,
      doDeleteCaseSummary
    })
  );
};

export const getOpenObjectByIdSemanticURL = (dxApiResponse: DxAPIResponseObject) => {
  const objectInfoID = getObjectInfoID(dxApiResponse);
  const objectClassName = getObjectClassName(dxApiResponse);
  let semanticURL = getSemanticURL(ACTION_GETOBJECT, { objectClassName });
  semanticURL = semanticURL?.replace('{objectID}', String(getDisplayCaseID(objectInfoID)));
  return semanticURL;
};
